import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getUserData } from "containers/services/data.transformers";
import AuthService from "utils/authService";
import loading from "assets/images/callback.json";
import Lottie from "lottie-react";
// import useFirebase from "components/notification";

const Callback = () => {
  // useFirebase();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    AuthService?.signinRedirectCallback().then(async () => {
      const user = await getUserData();
      window?.webengage?.user.login(user?.sub);
      window?.webengage?.user.setAttribute('hashed_phone', user?.sub);
      navigate("/home", { replace: true });
    });
    // eslint-disable-next-line
  }, [navigate]);

  return (
    <div className="flex flex-col bg-gradient-to-br from-primary-0 to-primary-2 w-screen h-screen  ">
      <div className=" fixed top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2">
        <div className="w-36 mb-8">
          <Lottie animationData={loading} loop={true} />
        </div>
        <span className="h-18px-medium text-white mt-8">
          {t("redirect-content")} ...
        </span>
      </div>
    </div>
  );
};
export default Callback;
